import script from "./Integration.vue?vue&type=script&setup=true&lang=js"
export * from "./Integration.vue?vue&type=script&setup=true&lang=js"

import "./Integration.vue?vue&type=style&index=0&id=242d48d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242d48d6"]])

export default __exports__